import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
interface CountryParamRequest {
    param: string;
    value: string;
}

export interface CountryParam {
    parameter: string;
    value: string | boolean;
}

@Injectable({
    providedIn: 'root',
})
export class CountryParamService {
    public constructor(private http: HttpClient) {}
    /**
     * Methode für Landesspezifische Parameter
     *
     * @param application Name der App (Beispiel: ECS, BASKET,...) muss der volle Name der App sein (keine Fuzzy-Suche)
     * @param parameter Name des Parameters (Beispiel: TEST oder TEST*)
     * @returns Gibt die Werte aus der /SEW/DG_PARAM oder /SEW/DG_PARAM_C zurück und mapped das Ergebnis entsprechend ('X' = true, '' = false)
     */
    public getParams(application: string, parameter: string): Observable<CountryParam[]> {
        return this.http
            .get<CountryParamRequest[]>(`/online-support/api/service/params/${application}/${parameter}`)
            .pipe(
                map((response) =>
                    response.map((element) => ({
                        parameter: element.param,
                        value: element.value === '' ? false : element.value === 'X' ? true : element.value,
                    }))
                )
            );
    }
}
